<template>
  <div class="block-ch">
    <div class="block-ch__box">
      <div class="block-ch__poster" data-aos="fade-up"><img src="../assets/img/ch-poster.png" alt=""></div>
      <div class="block-ch__letter letter letter-line-black" data-aos="fade-up">Ч.</div>
      <div class="block-ch__left">
        <div class="block-ch__image" data-aos="fade-up">
          <img src="../assets/img/ch-1.gif" alt="">
        </div>
      </div>
      <div class="block-ch__right">
        <div class="block-ch__title" data-aos="fade-up">
          Чарльстон
        </div>
        <div class="block-ch__text" data-aos="fade-up">Один из самых провокативных аморальных танцев того времени получил своё название в честь города в штате Южная Каролина. Название шоу, которое дало первую волну популярности чарльстону, довольно точно описывает всю суть той эпохи «ревущих двадцатых» — шоу называлось «Runnin’ Wild», что можно перевести как «Распутный образ жизни» или «Одичав вконец». Изначально чарльстон сам по себе являлся формой презрения к так называемым «сухарям» — то есть приверженцам сухого закона.</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'BlockF'
}
</script>

<style lang="sass">
  @media screen and (max-width: 999px)
    .block-ch__image
      width: vwm(342px)
      margin-left: vwm(44px)
    .block-ch__text
      font-size: vwm(17px)
      line-height: vwm(23px)
      width: 90vw
      margin-top: vwm(52px)
      margin-left: vwm(19px)
    .block-ch__title
      font-size: vwm(60px)
      margin-left: vwm(50px)
      margin-top: vwm(10px)
    .block-ch__letter
      margin-top: vwm(-239px)
      margin-left: vwm(159px)
      background-color: #fff
      position: relative
      z-index: 400
    .block-ch__poster
      width: vwm(183px)
      position: relative
      z-index: 200
      margin-top: vwm(99px)
      margin-left: vwm(-10px)
      transform: rotate(-8deg) !important
</style>
